
import { components } from '../../data/cpts/components.js'
const NOT_SENSORS = ['Resistor', 'Breadboard', 'Multimeter', 'Powersupply', 'Functiongen', 'Oscilloscope']
const notSensor = function (id) {
  return NOT_SENSORS.includes(id.substring(0, id.indexOf('_')))
}

const animationStart = function (f, vm, id, codename) {
  const arr = vm.$children
  arr.forEach(child => {
    // console.log(child.$el.id)
    if (child.$el.id === id) {
      // console.log("socket match:", child.$el.id)
      // console.log("socket:", state.socket.sockets[codename])
      child.start(state.socket.sockets[codename])
    }
  })
}
const animationStop = function (vcomps, vm) {
  const arr = vm.$children
  Object.values(vcomps).forEach(code => {
    const partid = components.convertCodeToId(code)
    // console.log(partid)
    arr.forEach(child => {
      if (child.$el.id === partid) {
        if (partid.includes('PhotoResistor') || !notSensor(child.$el.id)) {
          child.off()
        }
      }
    })
  })
}

const state = {
  message: '',
  logs: [],
  commands: [],
  inputs: [],
  status: 'disconnected',
  socket: {
    sockets: {},
    length: 1,
    uuid: '',
    url: '',
    valid_comps: []
  },
  vm: null
}

const getters = {}

const mutations = {
  clear (state) {
    state.message = ''
    state.logs = []
    state.commands = []
    state.inputs = []
    state.status = 'disconnected'
    state.socket = {
      sockets: {},
      length: 1,
      uuid: '',
      url: '',
      valid_comps: []
    }
  },
  addCommand (state, payload) {
    state.commands.push(payload)
  },
  connect (state, payload) {
    state.socket.valid_comps = payload.data.valid_comps
    state.socket.length += state.socket.valid_comps.length
    state.socket.uuid = payload.data.uuid
    state.socket.url = `wss://vlab.pusan.ac.kr/elec-module/${state.socket.uuid}`
    const msocket = new WebSocket(state.socket.url + '/main/')
    state.socket.sockets.main = msocket

    msocket.onopen = () => {
      state.status = 'ready'
      // console.log('메인 연결준비')
      this.commit('socket/sendMessage', { message: 'ready', socket: msocket })
      state.logs.push({ event: '메인 연결완료', data: state.socket.url })
      console.log({ event: '메인 연결완료', data: state.socket.url })

      msocket.onmessage = ({ data }) => {
        // console.log("socket main:", data)
        if (state.status === 'ready') {
          state.status = 'main-connected'
          this.commit('socket/connectPartSockets')
        }
      }
    }
  },
  connectPartSockets (state) {
    // console.log('try to connect on socket:', state.socket)
    for (let i = 0; i < state.socket.valid_comps.length; i++) {
      const codename = state.socket.valid_comps[i]
      try {
        const id = components.convertCodeToId(codename)
        // console.log('connectPartSockets', id, codename)
        this.commit('socket/createSocket', { id, codename })
      } catch (error) {
        // console.log(codename)
        console.warn(error)
      }
    }
  },
  createSocket (state, payload) {
    const { id, codename } = payload

    if (!id) {
      console.warn('failed to create socket', payload)
      return
    }
    // console.log('createSocket', id, codename)

    const signal = components.findSingalType(id)
    const url = `${state.socket.url}/${signal}/${codename}/`

    // console.log('socket.url:', state.socket.url)
    // console.log('signal:', signal)
    // console.log('codename:', codename)
    // console.log('socket url:', url)

    try {
      const sc = new WebSocket(url)
      sc.onopen = () => {
        state.status = id + '연결준비'
        sc.onmessage = ({ data }) => {
          if (data === 'ok') {
            state.socket.sockets[codename] = sc
            state.logs.push({ event: id + ' 연결완료', data: sc })
            console.log({ event: id + '연결완료', codename: codename, data: sc })
            // console.log(state.socket.sockets)
            setTimeout(() => {
              animationStart(state.socket.sockets, this.$app, id, codename)
            }, 0);
          }
        }
        this.commit('socket/sendMessage', { message: 'ready', socket: sc })
      }
      sc.onerror = () => {
        state.status = id + '연결에러'
        state.logs.push({ event: id + ' 연결에러', data: sc })
        console.log({ event: id + '연결에러', data: sc })
        setTimeout(() => {
          this.commit('socket/createSocket', id)
        }, 500)
      }
    } catch (error) {
      console.warn(error)
    }
  },
  disconnect (state) {
    if (!state.socket.sockets.main) return
    state.socket.sockets.main.close()
    // console.log(state.socket.sockets)
    const sockets = Object.keys(state.socket.sockets)
    for (const id of sockets) {
      state.socket.sockets[id].close()
      delete state.socket.sockets[id]
      state.logs.push({ event: id + '연결 해제' })
      console.log({ event: id + '연결 해제' })
    }
    animationStop(state.socket.valid_comps, this.$app)
    state.status = 'disconnected'
    state.logs = []
    state.commands = []
  },
  sendCommands (state) {
    if (state.socket) {
      console.log('sendCommands', state.commands)
      state.socket.send(JSON.stringify(state.commands))
      state.logs.push({ event: '메시지 전송', data: state.commands })
      state.commands = []
    }
  },
  sendMessage (state, payload) {
    if (payload.socket) {
      payload.socket.send(JSON.stringify(payload.message))
      state.logs.push({ event: '메인 ready', data: payload.message })
    }
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
